export const charSets = {
  cyrillic: 'АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ',
  latin: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
  numbers: '0123456789',
};
